import React from 'react'
import { NavLink } from 'react-router-dom'

export interface Breadcrumb {
  label: React.ReactElement | string
  to?: string
}

interface IProps {
  items: Breadcrumb[]
}

export const Breadcrumbs = (props: IProps): React.ReactElement => (
  <nav aria-label="breadcrumb">
    <ol className="breadcrumb">
      {props.items.map((breadcrumb, i) => (
        <li
          key={[breadcrumb.to, breadcrumb.label].join(':')}
          className={`breadcrumb-item${props.items.length - 1 === i ? ' active' : ''}`}
          aria-current={props.items.length - 1 === i ? 'page' : undefined}
        >
          <div className="text-truncate">
            {breadcrumb.to ? (
              <NavLink to={breadcrumb.to}>{breadcrumb.label}</NavLink>
            ) : (
              breadcrumb.label
            )}
          </div>
        </li>
      ))}
    </ol>
  </nav>
)
